export default "__VITE_ASSET__8935f61d__"